import { useCalcPriceQuery } from "../../api/queries/priceQueries";
import { mappingBookingState2RequestDTO } from "../../mapping/mappingBookingState2RequestDTO";
import { PriceDataHelper } from "./PriceDataHelper";

export const usePriceDataHelper = ({
  bookings,
}: {
  bookings: BookingState[];
}) => {
  const pl = bookings?.map((x) => mappingBookingState2RequestDTO(x)) ?? [];
  const bookingPrice = useCalcPriceQuery(pl, undefined, !!bookings?.length);

  const priceDataHelper = new PriceDataHelper(
    bookings,
    bookingPrice.data?.priceOfSingleBookings,
  );
  return {
    bookingPrice,
    priceDataHelper,
  };
};
